<template>
  <div class="home">
    <AppStart_PC />
  </div>
</template>

<script>
// @ is an alias to /src
import AppStart_PC from '@/components/AppStart_PC.vue'

export default {
  name: 'HomeView',
  components: {
    AppStart_PC
  }
}
</script>
